module.exports = __webpack_public_path__ + "img/story5.b875df60.png";